import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import InputMask from 'react-input-mask';
// import Countdown from 'react-countdown';

//Import Store
import store from '../../../../store';

//Import Utils
import { getUser } from '../../../../utils';

//Import Custom Component
import ValidateRegisterUser from '../../../features/validation/register_user';
import ValidateRegulations from '../../../features/validation/regulations';
import ValidateEmail from '../../../features/validation/email';
import ValidatePhone from '../../../features/validation/phone';

//Import Action 
import { checkIfEmail } from '../../../../action/checkIfEmail';
import { checkIfPhone } from '../../../../action/checkIfPhone';
import { registerClient, confirmSMSToken } from '../../../../action/users';

function ModalRegisterClient(props) {
  const user = getUser();
  const { backModal } = props;

  const [form, setForm] = useState({
    name: '',
    last_name: '',
    phone: '',
    email: '',
    password: '',
    passwordRep: '',
    regulations: false
  });
  const [error, setError] = useState({});
  const [errorRegulations, setErrorRegulations] = useState({});

  const handleChange = e => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
  };

  const handleChangeCheckbox = e => {
    const { name, checked } = e.target;
    setForm({
      ...form,
      [name]: checked
    });
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checkEmail, setCheckEmail] = useState(false);
  const [checkPhone, setCheckPhone] = useState(false);
  const [noPLnumber, setNoPLnumber] = useState(false);
  const [code, setCode] = useState('');
  const [errorCode, setErrorCode] = useState(false);

  const handleChangeNoPLnumber = (e) => {
    setNoPLnumber(e.target.checked);
    setForm({
      ...form,
      phone: user ? user.phone ? user.phone : "" : "",
      email: user ? user.email ? user.email : "" : "",
    });
  }

  useEffect(() => {
    if (!user && form.email && ValidateEmail(form.email)) {
      store.dispatch(checkIfEmail({email: form.email}, setCheckEmail));
    }
    setCheckEmail(false);
  }, [form.email]);

  useEffect(() => {
    if (!user && form.phone && ValidatePhone(form.phone)) {
      store.dispatch(checkIfPhone({phone: form.phone}, setCheckPhone));
    }
    setCheckPhone(false);
  }, [form.phone]);

  const [sendRegister, setSendRegister] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();

    setError(ValidateRegisterUser(form, noPLnumber));
    setErrorRegulations(ValidateRegulations(form));
    setIsSubmitting(true);
  };

  useEffect(() => {
    if(
        Object.keys(error).length === 0 && 
        Object.keys(errorRegulations).length === 0 && 
        isSubmitting && 
        checkEmail === false && 
        checkPhone === false
      ) {
      store.dispatch(registerClient(form, setSuccess, setSendRegister));
      setSendRegister(true);
    }
  }, [error, errorRegulations]);

  // const SMSTime = ({ seconds, completed }) => {
  //   if (completed) {
  //     return <button className="btn btn-sm btn-thirdy form-wide">Wyślij ponownie sms</button>;
  //   } else {
  //     return <div>ponowne wysłanie SMS możliwe za <span className="font-weight-bold">{seconds + " sekund"}</span></div>;
  //   }
  // };

  const handleConfirm = () => {
    if (code) {
      store.dispatch(confirmSMSToken(code));
    } else {
      setErrorCode(true)
    }
  }

  return (
    <>
      {
        !success ? 
          <>
            <div className="col-lg-12">
              <div className="heading mb-1">
                <h2 className="title">Utwórz konto</h2>
                <p>Utwórz konto, aby móc zamawiać produkty.</p>
              </div>
            </div>
            <div className="col-lg-12">
              <form onSubmit={handleSubmit} style={{ marginBottom: '0' }}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-1">
                      <label htmlFor="name">Imię <span className="required">*</span></label>
                      <input type="text" className="form-input form-wide" id="name" name="name" onChange={handleChange} value={form.name} />
                      {error.name && <span className="text-danger">{error.name}</span>}
                    </div>
                    <div className="mb-1">
                      <label htmlFor="last_name">Nazwisko <span className="required">*</span></label>
                      <input type="text" className="form-input form-wide" id="last_name" name="last_name" onChange={handleChange} />
                      {error.last_name && <span className="text-danger">{error.last_name}</span>}
                    </div>
                    <div className="mb-1">
                      {
                        noPLnumber ? 
                        <>
                          <label htmlFor="email">Adres e-mail {noPLnumber ? <span className="required">*</span> : null}</label>
                          <input type="text" className="form-input form-wide" id="email" name="email" onChange={handleChange} />
                          {error.email && <span className="text-danger">{error.email}</span>}<br/>
                          {checkEmail ? <span className="text-danger">Podany adres e-mail istnieje już w serwisie.</span> : null}
                        </>
                      :
                      <>
                        <label htmlFor="phone">Telefon {!noPLnumber ? <span className="required">*</span> : null}</label>
                        <InputMask mask="99999999999" maskChar={null} className="form-input form-wide" id="phone" name="phone" value={form.phone} onChange={handleChange} />
                        {error.phone && <span className="text-danger">{error.phone}</span>}<br/>
                        {checkPhone ? <div className="text-danger">Podany numer telefonu istnieje już w serwisie.</div> : null}
                      </>
                      }
                      <div className="custom-control custom-checkbox mt-2 m-0">
                        <input type="checkbox" className="custom-control-input" id="plnumber"
                          checked={noPLnumber}
                          onChange={(e) => handleChangeNoPLnumber(e)}
                        />
                        <label className="custom-control-label" htmlFor="plnumber" style={{cursor: 'pointer'}}>Nie mam polskiego numeru</label>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="mb-1">
                      <label htmlFor="password">Hasło <span className="required">*</span></label>
                      <input type="password" className="form-input form-wide" id="password" name="password" onChange={handleChange} />
                      {error.password && <span className="text-danger">{error.password}</span>}
                    </div>
                    <div className="mb-1">
                      <label htmlFor="rep-password">Powtórz hasło <span className="required">*</span></label>
                      <input type="password" className="form-input form-wide" id="rep-password" name="passwordRep" onChange={handleChange} />
                      {error.passwordRep && <span className="text-danger">{error.passwordRep}</span>}
                    </div>
                    <div className="custom-control custom-checkbox mt-2 m-0">
                      <input type="checkbox" className="custom-control-input" id="regulations" name="regulations"
                        checked={form.regulations}
                        onChange={handleChangeCheckbox}
                      />
                      <label className="custom-control-label" htmlFor="regulations" style={{cursor: 'pointer'}}>Akceptuję regulamin - <Link to={`${process.env.PUBLIC_URL}/regulamin`} className="link">zobacz</Link></label>
                    </div>
                    {errorRegulations.regulations && <span className="text-danger">{errorRegulations.regulations}</span>}
                  </div>
                  <div className="col-lg-6 mt-2">
                    <button type="button" className="btn btn-thirdy float-left" onClick={backModal("register-client")}>Wróć</button>
                  </div>
                  <div className="col-lg-6 mt-2">
                    <button type="submit" className="btn btn-primary float-right">Utwórz konto</button>
                  </div>
                </div>
              </form>
            </div>
            {
              sendRegister ? 
                <div className="loading-overlay" style={{background: 'rgba(0,0,0,.7)'}}>
                  <div className="bounce-loader">
                      <div className="bounce1"></div>
                      <div className="bounce2"></div>
                      <div className="bounce3"></div>
                  </div>
                </div>
              : null
            }
          </>
        : !noPLnumber ? 
          <div className="col-lg-12 mt-10 mb-10 text-center">
            <h2 style={{fontSize: '4rem'}} className="mb-4">Prosimy o potwierdzenie rejestracji</h2>
            <h3 className="font-weight-normal mb-1" style={{lineHeight: '2'}}>Wysłaliśmy wiadomość SMS na numer <span className="font-semibold">{form.phone}</span>.<br/>Zawiera ona kod który trzeba wpisać w polu poniżej, w celu potwierdzenia rejestracji konta.</h3>
            <div className="row justify-content-center mb-2">
              <div className="col-lg-4">
                <input type="text" className="form-input form-wide" onChange={(e) => setCode(e.target.value)} placeholder="Tu wpisz kod SMS" />
                {errorCode && <span className="text-danger">Wpisz kod SMS</span>}
                <button className="btn btn-secondary form-wide mt-1 mb-2" onClick={handleConfirm}>Potwierdzam</button>
                {/* <Countdown date={Date.now() + 60000} renderer={SMSTime} /> */}
              </div>
            </div>
          </div>
        : 
        <div className="col-lg-12 mt-10 mb-10 text-center">
          <h2 style={{fontSize: '4rem'}} className="mb-4">Prosimy o potwierdzenie adresu email</h2>
          <h3 className="font-weight-normal mb-4" style={{lineHeight: '2'}}>Wysłaliśmy wiadomość email na adres <span className="font-semibold">{form.email}</span>.<br/>Zawiera ona odnośnik, na który trzeba kliknąć, w celu potwierdzenia rejestracji konta.</h3>
          <Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-thirdy">Strona główna</Link>
        </div>
      }
    </>
  )
}

export default ModalRegisterClient;